import { evaluateXpath } from '../xpath'

export function getStravaCheckbox(labelText: string) {
  const checkboxXpath = `//label[contains(.,"${labelText}")]/input`
  const checkbox = evaluateXpath<HTMLInputElement>(document, checkboxXpath)[0]
  if (!checkbox) {
    throw new Error(`Could not find checkbox for label ${labelText}`)
  }
  return checkbox
}

export function getCurrentValueForStravaCheckbox(labelText: string) {
  const checkbox = getStravaCheckbox(labelText)
  return checkbox.checked
}

export function toggleStravaCheckbox(labelText: string) {
  const checkbox = getStravaCheckbox(labelText)
  checkbox.click()
}

export async function saveCurrentValueForStravaCheckbox(
  updateStoredInitialValuesFn: (Object, string?) => Promise<void>,
  mapToSettingsLabel: any,
  settingKey: string,
  recommendationKey: any,
): Promise<void> {
  if (!(settingKey in mapToSettingsLabel)) {
    throw Error(`Could not recognize ${settingKey}`)
  }

  const value = getCurrentValueForStravaCheckbox(mapToSettingsLabel[settingKey])

  return updateStoredInitialValuesFn(
    {
      [settingKey]: value,
    },
    recommendationKey,
  )
}
